<template>
  <div class="fragment">
    <div class="order-create__row custom-row">
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['calculatorEngraving_quantity'])"></div>
        <DefaultInput
            :label="$t('calculatorEngraving_quantity.localization_value.value')"
            :type="'text'"
            :placeholder="''"
            v-bind:class="{'ui-no-valid': FBM.data.PhotoPrint.validation.quantity}"
            :errorTxt="$t(`${FBM.data.PhotoPrint.validationTranslate.quantity}.localization_value.value`)"
            :error="FBM.data.PhotoPrint.validation.quantity"
            v-model="FBM.data.PhotoPrint.data.quantity"
            @input.native="changeEngravingPrice($event)"
            @change="(val) => {calculateEngravingPrice(); $emit('changeQuantity', FBM.data.PhotoPrint.data.customization, val)}"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['calculatorEngraving_productSize',])"></div>
        <DefaultSelect
            :options="photoPrintSizeOptions"
            :label="$t('calculatorEngraving_productSize.localization_value.value')"
            :otherValue="'calculatorCustomization'"
            :selected="FBM.data.PhotoPrint.data.size"
            @change="(val) => {FBM.data.PhotoPrint.data.size = val; calculateEngravingPrice()}"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['calculatorEngraving_product',])"></div>
        <DefaultSelect
            :options="photoPrintCustomOptions"
            :label="$t('calculatorEngraving_product.localization_value.value')"
            :otherValue="'calculatorCustomization'"
            :selected="FBM.data.PhotoPrint.data.customization"
            @change="changeCustomization"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_engravingPrice'])"></div>
        <DefaultInput
            :label="$t('fbm_engravingPrice.localization_value.value')"
            :type="'text'"
            :disabled="true"
            v-model="FBM.data.PhotoPrint.data.resultCost"
        />
      </div>
    </div>

    <div
        v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate(['fbm_engravingAcceptFiles'])"></div>
      {{ $t('fbm_photoPrintFiles.localization_value.value') }}
    </div>
    <div class="order-create__row custom-row">
      <div class="custom-col position-relative"
           v-if="FBM.data.PhotoPrint.data.File.data.maxCountFiles - Object.keys(FBM.data.PhotoPrint.data.File.data.downloadFiles).length > 0">
        <DropZone class="drop-zone-bg"
                  :parentFiles="FBM.data.PhotoPrint.data.File.data.files"
                  :multiple="true"
                  :maxCount="FBM.data.PhotoPrint.data.File.data.maxCountFiles - FBM.data.PhotoPrint.data.File.data.downloadFiles.length"
                  :maxSize="FBM.data.PhotoPrint.data.File.data.maxSizeFiles"
                  @changeImg="(files, maxSize) => {changeFile(files, maxSize)}"
                  :accept="'/*'"
        />
        <div class="error-field ml-3" v-if="FBM.data.PhotoPrint.data.File.validation.files">
          {{ $t('common_fileIsRequired.localization_value.value') }}
        </div>
      </div>

      <div class="custom-col mt-3"
           v-if="Object.keys(FBM.data.PhotoPrint.data.File.data.downloadFiles).length > 0"
      >
        <div class="custom-row product-img-row">
          <div class="custom-col custom-col--16 custom-col--md-25 custom-col--sm-100"
               v-for="(item, index) in FBM.data.PhotoPrint.data.File.data.downloadFiles"
               :key="index">
            <DownloadFileBlock
                :file="item"
                :customTypeFile="'psd'"
                @removeFile="(id) => {removeFile(id, index)}"
            />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import DefaultInput from "@/components/UI/inputs/DefaultInput/DefaultInput";
import DownloadFileBlock from "@/components/coreComponents/DownloadFileBlock/DownloadFileBlock";
import DropZone from "@/components/coreComponents/DropZone/DropZone";
import DefaultSelect from "@/components/UI/selectiones/DefaultSelect/DefaultSelect";
export default {
  name: "PhotoPrint",
  components: {DefaultSelect, DropZone, DownloadFileBlock, DefaultInput},

  props: {
    FBM: Object,
    photoPrintCustomOptions: Array,
    photoPrintSizeOptions: Array,
  },

  mounted() {

  },

  methods: {

    changeCustomization(val) {
      let oldCustomization = this.FBM.data.PhotoPrint.data.customization
      this.FBM.data.PhotoPrint.data.customization = val;
      this.calculateEngravingPrice();
      this.$emit('changeCustomization', oldCustomization, val, this.FBM.data.PhotoPrint.data.quantity)
    },

    changeEngravingPrice(event) {
      this.FBM.data.PhotoPrint.data.quantity = event.target.value.replace(',', '.').replace(/[^0-9.]/g, '')
    },

    calculateEngravingPrice() {
      if(this.FBM.data.PhotoPrint.data.quantity.length === 0) {
        return
      }

      let data = this.FBM.data.PhotoPrint.prepareData()

      this.$store.dispatch('getPhotoPrintCalcResult', data).then(response => {
        if(this.getRespData(response)?.rate) {
          this.FBM.data.PhotoPrint.data.resultCost = parseFloat(this.getRespData(response)?.rate).toFixed(2)
        }
      })
    },

    changeFile(files, maxSizeError) {
      this.FBM.data.PhotoPrint.data.File.setFiles(files)

      this.FBM.data.PhotoPrint.data.File.setFilesMaxSizeError(maxSizeError)

      this.calculateEngravingPrice()
    },

    removeFile(id, index){

      let text = {
        title: 'common_AreYouSure',
        txt: '',
        yes: 'common_confirmDelete',
        no: 'common_confirmNo'
      }

      let confirm = () => {

        this.$store.dispatch('removeUserDocument', id).then(() => {

          this.FBM.data.PhotoPrint.data.File.removeDownloadFile(index)
          // this.FBM.data.PhotoPrint.data.File.setDownloadFiles([])

          this.calculateEngravingPrice()
        })

        this.$store.commit('setConfirmDeletePopup', false)
        return true
      }

      this.deleteFunc(text, confirm)


    },
  },

}
</script>

<style scoped>

</style>